import React from 'react'
import logo from './images/logos/TROPHYEDDYLOGO_graypurple_textstacked.png'
import altLogo from './images/logos/TROPHYEDDYLOGO_graypurple_text.png'
import instaLogo from './images/logos/linkIcons/5335781_camera_instagram_social media_instagram logo_icon.png'
import tikTokLogo from './images/logos/linkIcons/5588510_editting_multimedia_social media_tiktok_video_icon.png'
import spotifyLogo from './images/logos/linkIcons/287645_spotify_icon.png'
import youtubeLogo from './images/logos/linkIcons/5305164_play_video_youtube_youtube logo_icon.png'
import { useNavigate } from 'react-router-dom';
import "./Navbar.css"
import Draggable from 'react-draggable'

function Navbar() {
    const navigate = useNavigate();

    const navigateShows = () => {
        navigate("/shows")
    }
    const navigateHome = () => {
        navigate("/home")
    }

    const navigateGallery = () => {
        navigate("/gallery")
    }

    return (
        <nav className="navbar">
          <div className='container buttons'>
            <div className='subcontainer'>
            <div className='item'>
              <a href="https://open.spotify.com/artist/1cZcffB2Ll163iqJ0312Xl?si=Mt4FMtk_TW2sxlYBOUOIww" target="_blank" rel="noopener noreferrer" className="external-link noselect">
              music
            </a>
            </div>
            <div className='item'>
              <h2 className='external-link noselect' onClick={navigateShows}> shows </h2>
            </div>
            <div className='item'>
              <h2 className='external-link noselect' onClick={navigateHome}> gallery </h2>
            </div>
            </div>
          </div>


          <div className="container logo noselect" onClick={navigateHome}>
            <Draggable>
              <div>
                <img src={altLogo} alt="Logo" className="logo" /> 
              </div>
             </Draggable>
          </div>

          <div className='container icons'>
            <div className='subcontainer'>
            <div className='icon-item'>
              <a href="https://instagram.com/trophyeddy" target="_blank" rel="noopener noreferrer" className="picture-button">
                <img src={instaLogo} alt="Button" />
              </a>
            </div>
            <div className='icon-item'>
              <a href="https://www.youtube.com/channel/UCJ6C3bv1yx4Egp0uJG6C1xA" target="_blank" rel="noopener noreferrer" className="picture-button">
                <img src={youtubeLogo} alt="Button" />
              </a>
            </div>
            <div className='icon-item'>
              <a href="https://www.tiktok.com/@trophyeddy" target="_blank" rel="noopener noreferrer" className="picture-button">
                <img src={tikTokLogo} alt="Button" />
              </a>
            </div>
          </div> 
          </div>
        </nav>
    )
}

export default Navbar;
